"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "../tags.model";
export let BindShopFormModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.autoCookieSync = true;
    this.name = "";
    this.guid = "";
    this.password = "";
    this.account = "";
    this.company_name = "";
    this.is_auto_cookie_sync = true;
    this.lock_account = false;
    this.ui_language = "";
    this.mode = "";
    this.useragent = "";
    this.platform_id = "";
    this.sub_platforms = [];
    this.create_env_setting = false;
    this.ebusiness_id = "";
    this.code = "";
    this.resolution_mode = "";
    this.screen = "";
    this.shop_lock = false;
    this.shop_lock_num = 0;
    this.third_party_cookie_auth = false;
    this.safety_protection = false;
    this.safety_mark = false;
    this.platform_style = "";
    this.ebusiness_type = "";
    this.shop_url = "";
    this.useragent_package = {
      androidUa: "",
      linuxUa: "",
      macUa: "",
      winUa: ""
    };
    this.users = {
      model: "data.set",
      datas: [],
      total: 0
    };
    this.cookie_mode = {
      mode: "AUTO_SYNC",
      owner_id: ""
    };
    this.file_uid = "";
    this.files = [];
    this.seller_fingerprint = "";
    this.seller_secret = "";
    this.twoStepValidSecretId = "";
    this.twoStepBlackList = null;
  }
};
BindShopFormModel.model = "shop.form";
BindShopFormModel = __decorateClass([
  Annotation.ModelMeta
], BindShopFormModel);
export let BindShopProFormModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.oldId = "";
    this.name = "";
    this.vdId = "";
    this.ebusinessPlatformId = "";
    this.ebusinessId = "";
    this.url = null;
    this.account = null;
    this.password = null;
    this.lockAccount = false;
    this.authUsers = null;
    this.extEbusinessPlatforms = null;
    this.browser = null;
    this.unifyEnv = false;
    this.osUserAgent = null;
    this.resolution = null;
    this.uiLanguage = "";
    this.cookieSync = "";
    this.shopLock = null;
    this.thirdPartyAuth = false;
    this.sellerFingerprint = null;
    this.sellerSecret = null;
    this.shopFiles = null;
    this.twoStepValidSecret = null;
    this.twoStepValidBlackList = null;
    this.mark = new TagsModel();
    this.prohibiteThirdPartyLogin = false;
  }
};
BindShopProFormModel.model = "shop.pro";
BindShopProFormModel = __decorateClass([
  Annotation.ModelMeta
], BindShopProFormModel);
